// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Document
 * ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

:where(html) {
  line-height: 1.15; /* 1 */
}

/* Sections
 * ========================================================================== */

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Edge, Firefox, and Safari.
 */

:where(h1) {
  font-size: 2em;
  margin-block-end: 0.67em;
  margin-block-start: 0.67em;
}

/* Grouping content
 * ========================================================================== */

/**
 * Remove the margin on nested lists in Chrome, Edge, and Safari.
 */

:where(dl, ol, ul) :where(dl, ol, ul) {
  margin-block-end: 0;
  margin-block-start: 0;
}

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Correct the inheritance of border color in Firefox.
 */

:where(hr) {
  box-sizing: content-box; /* 1 */
  color: inherit; /* 2 */
  height: 0; /* 1 */
}

/* Text-level semantics
 * ========================================================================== */

/**
 * Add the correct text decoration in Safari.
 */

:where(abbr[title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

:where(b, strong) {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

:where(code, kbd, pre, samp) {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

:where(small) {
  font-size: 80%;
}

/* Tabular data
 * ========================================================================== */

/**
 * 1. Correct table border color in Chrome, Edge, and Safari.
 * 2. Remove text indentation from table contents in Chrome, Edge, and Safari.
 */

:where(table) {
  border-color: currentColor; /* 1 */
  text-indent: 0; /* 2 */
}

/* Forms
 * ========================================================================== */

/**
 * Remove the margin on controls in Safari.
 */

:where(button, input, select) {
  margin: 0;
}

/**
 * Remove the inheritance of text transform in Firefox.
 */

:where(button) {
  text-transform: none;
}

/**
 * Correct the inability to style buttons in iOS and Safari.
 */

:where(button, input:is([type="button" i], [type="reset" i], [type="submit" i])) {
  -webkit-appearance: button;
}

/**
 * Add the correct vertical alignment in Chrome, Edge, and Firefox.
 */

:where(progress) {
  vertical-align: baseline;
}

/**
 * Remove the inheritance of text transform in Firefox.
 */

:where(select) {
  text-transform: none;
}

/**
 * Remove the margin in Firefox and Safari.
 */

:where(textarea) {
  margin: 0;
}

/**
 * 1. Correct the odd appearance in Chrome, Edge, and Safari.
 * 2. Correct the outline style in Safari.
 */

:where(input[type="search" i]) {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Safari.
 */

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/**
 * Correct the text style of placeholders in Chrome, Edge, and Safari.
 */

::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}

/**
 * Remove the inner padding in Chrome, Edge, and Safari on macOS.
 */

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style upload buttons in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/**
 * Remove the inner border and padding of focus outlines in Firefox.
 */

:where(button, input:is([type="button" i], [type="color" i], [type="reset" i], [type="submit" i]))::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus outline styles unset by the previous rule in Firefox.
 */

:where(button, input:is([type="button" i], [type="color" i], [type="reset" i], [type="submit" i]))::-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Remove the additional :invalid styles in Firefox.
 */

:where(:-moz-ui-invalid) {
  box-shadow: none;
}

/* Interactive
 * ========================================================================== */

/*
 * Add the correct styles in Safari.
 */

:where(dialog) {
  background-color: white;
  border: solid;
  color: black;
  height: fit-content;
  left: 0;
  margin: auto;
  padding: 1em;
  position: absolute;
  right: 0;
  width: fit-content;
}

:where(dialog:not([open])) {
  display: none;
}

/*
 * Add the correct display in all browsers.
 */

:where(summary) {
  display: list-item;
}

:root {
  --doc-height: 100%;
}

* {
  box-sizing: border-box;
}

html, body {
  overscroll-behavior-x: none;
}

body {
  font-family: var(--pri-ft-fm);
  font-size: var(--pri-ft-sz);
  font-weight: 400;
  line-height: 1;
  color: var(--pri-clr);
  margin: 0;
}

body.is-fixed {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

body.is-immuned {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

body.is-credential ._refLayoutContainer  {
  min-height: calc(100vh - 120px);
  margin-top: 120px;
}

body.is-credential ._refLayoutContainer > section {
  height: calc(100vh - 120px);
}

b {
  font-weight: 400;
}

b, 
strong {
  font-weight: 500 !important;
}

a {
  position: relative;
  cursor: pointer;
  color: var(--pri-clr-lnk__hvr);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

button {
  font-family: var(--pri-ft-fm);
  font-size: var(--pri-ft-sz);
  font-weight: 400;
  line-height: 1;
  color: var(--pri-clr);
  display: inline-grid;
  height: 30px;
  cursor: pointer;
  border: 0;
  border-radius: var(--sec-rd);
  outline: none;
  position: relative;
  align-items: center;
  padding: 0 16px;
  -webkit-user-select: none;
          user-select: none;
  text-transform: capitalize;
  transform-origin: 100% 0%;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  &:disabled {
    pointer-events: none;
    opacity: .7;
    cursor: default;
  }
}
  
label {
  font-weight: 400;
}

input, 
textarea {
  font-family: var(--pri-ft-fm);
  font-size: var(--pri-ft-sz);
  font-weight: 400;
  position: relative;
  border: 1px solid var(--ck-clr-ln);
  border-radius: .5rem;
  background-color: var(--cl-clr-bg);
  color: var(--inp-clr);
  width: 100%;
  &:not(:disabled):not([type='submit']) {
    &:focus, &:active, &:active:focus {
      border: 1px solid var(--pri-clr-ln__fc);
      box-shadow: none;
      outline: none;
    }
  } 
  &:disabled {
    background-color: var(--mt-clr-bg__fc);
    color: var(--mt-clr);
  }
  &::placeholder {
    font-style: italic;
  }
}

textarea[name='input-message'] {
  &:focus, 
  &:active, 
  &:active:focus {
    box-shadow: none !important;
    border: 0 !important;
    outline: none !important;
  }
}

input {
  height: 30px;
  padding: 8px 12px;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
}

textarea {
  padding: 1em;
  min-height: 100px;
  resize: none;
}

p {
  margin-top: 0;
  margin-bottom: 10px;
  line-height: 1.3;
  letter-spacing: 0.3px;
}

h1, 
h2, 
h3, 
h4 {
  font-weight: 600;
  margin: 0;
}

h1 {
  font-size: 22px;
  line-height: 34px;
  @media (min-width: 768px) {
    font-size: 40px;
    line-height: 1.2;
  }
}

h2 {
  font-size: 20px;
  line-height: 32px;
  @media (min-width: 425px) {
    font-size: 24px;
    line-height: 36px;
  }
}

h3 {
  font-size: 14px;
  line-height: 28px;
  letter-spacing: normal;
  @media (min-width: 425px) {
    font-size: 18px;
    line-height: 30px;
  }
}

p {
  margin: 0 0 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

input[type=number] {
  -moz-appearance: textfield !important;
}

input[type="checkbox"] {
  height: 14px;
  width: 14px;
  background-color: var(--pri-clr-bg);
  border: 1px solid var(--ck-clr-ln);
  border-radius: 3px;
}

[draggable="true"] {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  z-index: 1;
}

[draggable="true"] * {
  cursor: move;
}`, "",{"version":3,"sources":["webpack://./node_modules/@csstools/normalize.css/normalize.css","webpack://./src/index.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,iBAAiB,EAAE,MAAM;AAG3B;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,cAAc;EACd,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE;;AAEF;EACE,uBAAuB,EAAE,MAAM;EAC/B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;AACnB;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;;EAEE;;AAEF;EACE,mBAAmB;AACrB;;AAEA;;;EAGE;;AAEF;EACE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;;AAEA;;EAEE;;AAEF;EACE,cAAc;AAChB;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,0BAA0B,EAAE,MAAM;EAClC,cAAc,EAAE,MAAM;AACxB;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,SAAS;AACX;;AAEA;;EAEE;;AAEF;EACE,oBAAoB;AACtB;;AAEA;;EAEE;;AAEF;EACE,0BAA0B;AAC5B;;AAEA;;EAEE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;;EAEE;;AAEF;EACE,oBAAoB;AACtB;;AAEA;;EAEE;;AAEF;EACE,SAAS;AACX;;AAEA;;;EAGE;;AAEF;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;EAEE;;AAEF;;EAEE,YAAY;AACd;;AAEA;;EAEE;;AAEF;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE;;AAEF;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE;;AAEF;EACE,8BAA8B;AAChC;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;AAClB;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EAEZ,mBAAmB;EACnB,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EAER,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;AACpB;;AC9PA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,8HAAkK;EAClK;IACE,oBAAoB;IACpB,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,kCAAkC;EAClC,qBAAqB;EACrB,WAAW;EACX;IACE;MACE,uCAAuC;MACvC,gBAAgB;MAChB,aAAa;IACf;EACF;EACA;IACE,sCAAsC;IACtC,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;IAGE,2BAA2B;IAC3B,oBAAoB;IACpB,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB;;IAEE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Document\n * ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\n:where(html) {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n * ========================================================================== */\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Edge, Firefox, and Safari.\n */\n\n:where(h1) {\n  font-size: 2em;\n  margin-block-end: 0.67em;\n  margin-block-start: 0.67em;\n}\n\n/* Grouping content\n * ========================================================================== */\n\n/**\n * Remove the margin on nested lists in Chrome, Edge, and Safari.\n */\n\n:where(dl, ol, ul) :where(dl, ol, ul) {\n  margin-block-end: 0;\n  margin-block-start: 0;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Correct the inheritance of border color in Firefox.\n */\n\n:where(hr) {\n  box-sizing: content-box; /* 1 */\n  color: inherit; /* 2 */\n  height: 0; /* 1 */\n}\n\n/* Text-level semantics\n * ========================================================================== */\n\n/**\n * Add the correct text decoration in Safari.\n */\n\n:where(abbr[title]) {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\n:where(b, strong) {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\n:where(code, kbd, pre, samp) {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\n:where(small) {\n  font-size: 80%;\n}\n\n/* Tabular data\n * ========================================================================== */\n\n/**\n * 1. Correct table border color in Chrome, Edge, and Safari.\n * 2. Remove text indentation from table contents in Chrome, Edge, and Safari.\n */\n\n:where(table) {\n  border-color: currentColor; /* 1 */\n  text-indent: 0; /* 2 */\n}\n\n/* Forms\n * ========================================================================== */\n\n/**\n * Remove the margin on controls in Safari.\n */\n\n:where(button, input, select) {\n  margin: 0;\n}\n\n/**\n * Remove the inheritance of text transform in Firefox.\n */\n\n:where(button) {\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style buttons in iOS and Safari.\n */\n\n:where(button, input:is([type=\"button\" i], [type=\"reset\" i], [type=\"submit\" i])) {\n  -webkit-appearance: button;\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Edge, and Firefox.\n */\n\n:where(progress) {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the inheritance of text transform in Firefox.\n */\n\n:where(select) {\n  text-transform: none;\n}\n\n/**\n * Remove the margin in Firefox and Safari.\n */\n\n:where(textarea) {\n  margin: 0;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome, Edge, and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n:where(input[type=\"search\" i]) {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Safari.\n */\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */\n\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n\n/**\n * Remove the inner padding in Chrome, Edge, and Safari on macOS.\n */\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style upload buttons in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/**\n * Remove the inner border and padding of focus outlines in Firefox.\n */\n\n:where(button, input:is([type=\"button\" i], [type=\"color\" i], [type=\"reset\" i], [type=\"submit\" i]))::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus outline styles unset by the previous rule in Firefox.\n */\n\n:where(button, input:is([type=\"button\" i], [type=\"color\" i], [type=\"reset\" i], [type=\"submit\" i]))::-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Remove the additional :invalid styles in Firefox.\n */\n\n:where(:-moz-ui-invalid) {\n  box-shadow: none;\n}\n\n/* Interactive\n * ========================================================================== */\n\n/*\n * Add the correct styles in Safari.\n */\n\n:where(dialog) {\n  background-color: white;\n  border: solid;\n  color: black;\n  height: -moz-fit-content;\n  height: fit-content;\n  left: 0;\n  margin: auto;\n  padding: 1em;\n  position: absolute;\n  right: 0;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n:where(dialog:not([open])) {\n  display: none;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\n:where(summary) {\n  display: list-item;\n}\n","@import-normalize;\n\n:root {\n  --doc-height: 100%;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  overscroll-behavior-x: none;\n}\n\nbody {\n  font-family: var(--pri-ft-fm);\n  font-size: var(--pri-ft-sz);\n  font-weight: 400;\n  line-height: 1;\n  color: var(--pri-clr);\n  margin: 0;\n}\n\nbody.is-fixed {\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\nbody.is-immuned {\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\nbody.is-credential ._refLayoutContainer  {\n  min-height: calc(100vh - 120px);\n  margin-top: 120px;\n}\n\nbody.is-credential ._refLayoutContainer > section {\n  height: calc(100vh - 120px);\n}\n\nb {\n  font-weight: 400;\n}\n\nb, \nstrong {\n  font-weight: 500 !important;\n}\n\na {\n  position: relative;\n  cursor: pointer;\n  color: var(--pri-clr-lnk__hvr);\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\nbutton {\n  font-family: var(--pri-ft-fm);\n  font-size: var(--pri-ft-sz);\n  font-weight: 400;\n  line-height: 1;\n  color: var(--pri-clr);\n  display: inline-grid;\n  height: 30px;\n  cursor: pointer;\n  border: 0;\n  border-radius: var(--sec-rd);\n  outline: none;\n  position: relative;\n  align-items: center;\n  padding: 0 16px;\n  user-select: none;\n  text-transform: capitalize;\n  transform-origin: 100% 0%;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;\n  &:disabled {\n    pointer-events: none;\n    opacity: .7;\n    cursor: default;\n  }\n}\n  \nlabel {\n  font-weight: 400;\n}\n\ninput, \ntextarea {\n  font-family: var(--pri-ft-fm);\n  font-size: var(--pri-ft-sz);\n  font-weight: 400;\n  position: relative;\n  border: 1px solid var(--ck-clr-ln);\n  border-radius: .5rem;\n  background-color: var(--cl-clr-bg);\n  color: var(--inp-clr);\n  width: 100%;\n  &:not(:disabled):not([type='submit']) {\n    &:focus, &:active, &:active:focus {\n      border: 1px solid var(--pri-clr-ln__fc);\n      box-shadow: none;\n      outline: none;\n    }\n  } \n  &:disabled {\n    background-color: var(--mt-clr-bg__fc);\n    color: var(--mt-clr);\n  }\n  &::placeholder {\n    font-style: italic;\n  }\n}\n\ntextarea[name='input-message'] {\n  &:focus, \n  &:active, \n  &:active:focus {\n    box-shadow: none !important;\n    border: 0 !important;\n    outline: none !important;\n  }\n}\n\ninput {\n  height: 30px;\n  padding: 8px 12px;\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n}\n\ntextarea {\n  padding: 1em;\n  min-height: 100px;\n  resize: none;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 10px;\n  line-height: 1.3;\n  letter-spacing: 0.3px;\n}\n\nh1, \nh2, \nh3, \nh4 {\n  font-weight: 600;\n  margin: 0;\n}\n\nh1 {\n  font-size: 22px;\n  line-height: 34px;\n  @media (min-width: 768px) {\n    font-size: 40px;\n    line-height: 1.2;\n  }\n}\n\nh2 {\n  font-size: 20px;\n  line-height: 32px;\n  @media (min-width: 425px) {\n    font-size: 24px;\n    line-height: 36px;\n  }\n}\n\nh3 {\n  font-size: 14px;\n  line-height: 28px;\n  letter-spacing: normal;\n  @media (min-width: 425px) {\n    font-size: 18px;\n    line-height: 30px;\n  }\n}\n\np {\n  margin: 0 0 10px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none !important;\n  margin: 0 !important;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield !important;\n}\n\ninput[type=\"checkbox\"] {\n  height: 14px;\n  width: 14px;\n  background-color: var(--pri-clr-bg);\n  border: 1px solid var(--ck-clr-ln);\n  border-radius: 3px;\n}\n\n[draggable=\"true\"] {\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  z-index: 1;\n}\n\n[draggable=\"true\"] * {\n  cursor: move;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
